import { createRoute, Navigate } from "@tanstack/react-router";
import { useSession } from "../auth-client";
import { useActorContextQuery } from "@/frontend/queries/index";
import { Route as rootRoute } from "./__root";
import { LoadingScreen } from "@/frontend/components/onboarding/Onboarding";
import { SyntheticHospitalLoginView } from "@/frontend/components/synthetic-hospital/SyntheticHospitalLoginView";

/**
 * In-portal Synthetic Hospital login page. Reached from the picker's
 * Connect click on the Synthetic Hospital tile — session-only, no OAuth
 * params, the patient session cookie is the auth.
 */
export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/synthetic-hospital/login",
  component: SyntheticHospitalLoginPage,
});

function SyntheticHospitalLoginPage() {
  const { data: session, isPending: sessionPending } = useSession();
  const { data: actor, isPending: actorPending } = useActorContextQuery(!!session);
  if (sessionPending || (session && actorPending)) return <LoadingScreen />;
  if (!session) return <Navigate to="/" />;
  if (actor?.actorType !== "patient" || !actor.hasActivePatientMembership) {
    return <Navigate to="/" />;
  }
  return <SyntheticHospitalLoginView />;
}
